<template>
    <div class="page">
        <div class="centercontainer">
            <img class="logo" :src="assets.logoImage" @click="backHome">
            <a-form-model layout="vertical" :rules="dRules" :model="dFormData" ref="myForm">
                <a-form-model-item class="form-item" label="手机号码" ref="phone" prop="phone">
                    <a-input v-model="dFormData.phone" placeholder="请输入手机号码">
                        <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                    </a-input>
                </a-form-model-item>
                <a-form-model-item class="form-item" label="验证码" ref="smsCode" prop="smsCode">
                    <a-input v-model="dFormData.smsCode" placeholder="请输入验证码">
                        <a-button slot="addonAfter" type="primary" @click="getSmsCode">获取验证码</a-button>
                    </a-input>
                </a-form-model-item>
                <a-form-model-item class="form-item" label="登录密码" prop="password">
                    <a-input v-model="dFormData.password" type="password" placeholder="请输入密码">
                        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
                    </a-input>
                </a-form-model-item>
                <a-form-model-item class="form-item">
                    <a-radio-group v-model="dFormData.sex">
                        <a-radio :value="1">男</a-radio>
                        <a-radio :value="2">女</a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item class="form-item">
                    <a-button type="primary" @click="submitForm('myForm')">注册</a-button>
                </a-form-model-item>
                <a-form-model-item class="form-item">
                    <a-button type="primary" @click="login">登录</a-button>
                </a-form-model-item>
                <a-form-model-item class="form-item" v-if="moduleGroup == 2">
                    <a-button type="primary" @click="weixinLogin">微信登录</a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
    </div>
</template>

<script>

    import { sms, register } from "@/api/api"
    import { strIsEmpty } from '@/utils/web-utils';
    import {isMobile} from '@/utils/validate';
    import { postAction, getAction, deleteAction } from "@/api/api-manage";

    export default {
        name: "Register",
        data(){
            return {
                dFormData: {
                    phone: '',
                    smsCode: '',
                    password: '',
                    sex:2,
                },
                dRules: {
                    phone: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                    ],
                    smsCode: [
                        { required: true, message: '请输入手机验证码', trigger: 'blur' },
                    ],
                    password: [
                        { required: true, message: '请输入登录密码', trigger: 'blur' },
                        { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
                    ]
                },
                assets: {
                    logoImage:require('@/assets/logo.png'),
                },

                // 功能模块组别：1=后台，2=web
                moduleGroup: 1,

            }
        },
        methods: {
            pageInit:function () {
                this.moduleGroup = window._CONFIG['moduleGroup'];
            },
            /** 提交表单 */
            submitForm: function (formName) {
                let that = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.register();
                    } else {
                        return false;
                    }
                });
            },
            /** 获取校验码 */
            getSmsCode: function () {
                let that = this;
                if(strIsEmpty(this.dFormData.phone)){
                    this.$message.error('手机号码不能为空');
                    return;
                }else{
                    if(isMobile(this.dFormData.phone) == false){
                        this.$message.error('手机号码格式错误，请重新输入');
                        return;
                    }
                }
                let params = {};
                params.account = this.dFormData.phone
                params.smsType = 1;
                params.loginType = 1;
                sms(params).then((res) => {
                    console.log('发送验证码返回结果 = ' + JSON.stringify(res));
                    if (res.success) {
                        if(res.code == 200){
                            this.$message.success('验证码已经发送');
                        }else{
                            // code : 1=短信已经发送，验证码10分钟有效，2=手机号已经注册，3=手机号码不合法或被屏蔽
                            switch (res.code) {
                                case 1:
                                    this.$message.error(res.message);
                                    break;
                                case 2:
                                    this.$message.error(res.message);
                                    break;
                                case 3:
                                    this.$message.error(res.message);
                                    break;
                            }
                        }
                    } else {
                        this.$message.error('获取校验码失败，请重试');
                    }
                });
            },
            /** 注册 */
            register: function () {
                let that = this;
                if(isMobile(this.dFormData.phone) == false){
                    this.$message.error('手机号码格式错误，请重新输入');
                    return;
                }
                if(strIsEmpty(this.dFormData.smsCode)){
                    this.$message.error('手机验证码不能为空');
                    return;
                }

                let params = {};
                params.account = this.dFormData.phone;
                params.smsCode = this.dFormData.smsCode;
                params.password = this.dFormData.password;
                params.sex = this.dFormData.sex;
                params.loginType = 1;
                //this.$message.error(params.phone + "  " + params.smsCode + "   " + params.password + "   " + params.sex);

                register(params).then((res) => {
                    if (res.success) {
                        if(res.code == 200){
                            this.$alert('注册成功，请登录', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    that.$router.go(-1);
                                }
                            });
                        }else{
                            //code: 1=手机号已经注册，2=手机验证码错误
                            switch (res.code) {
                                case 1:
                                    this.$message.error(res.message);
                                    break;
                                case 2:
                                    this.$message.error(res.message);
                                    break;
                            }
                        }
                    } else {
                        this.$message.error('获取校验码失败，请重试');
                    }
                });

            },


            /**  返回主页 */
            backHome: function() {
                if(window._CONFIG['moduleGroup'] == 2){
                    this.$router.push({path:"/web/index", params: {}});
                }
            },
            login: function () {
                this.$router.push({path:"/user/login", params: {}});
            },
            // --------------------------------------------------------------------------------------- 微信登录 start
            /**  微信登录 */
            weixinLogin: function() {
                console.log('微信登录...');
                this.weixinLoginObj = null;
                let that = this;
                this.$nextTick(() => {
                    let params = {};
                    getAction(that.url.getOpenLoginConnectInfo, params).then(res=>{
                        if(res.success){
                            /*that.weixinLoginObj = new WxLogin({
                                self_redirect:true,
                                id: 'divWeixinQrcode',                                  // 需要显示的容器id
                                appid: res.result.appid,                                // 公众号appid wx*******
                                scope: res.result.scope,                                // 网页默认即可
                                redirect_uri: res.result.redirectUri,                   // 授权成功后回调的url
                                state: res.result.state,                                // 可设置为简单的随机数加session用来校验
                                style: 'black',                                         // 提供"black"、"white"可选。二维码的样式
                                href: ''                                                // 外部css文件url，需要https
                            });*/
                            let url = 'https://open.weixin.qq.com/connect/qrconnect?appid='+res.result.appid+'&redirect_uri='+res.result.redirectUri+'&response_type=code&scope='+res.result.scope+'&state='+res.result.state+'#wechat_redirect';
                            window.location.href = url;
                        }else{
                            that.$message.warning(res.message);
                        }
                    }).catch(err => {
                        that.$message.error(err);
                    });
                });
            },
            // --------------------------------------------------------------------------------------- 微信登录 end

        },
        created() {
            this.pageInit();
        },
    }
</script>

<style lang="less" scoped>
.page{
    position: absolute;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px !important;
    background-color: #ffffff;
    .form-item{
        max-width: 300px;
    }
}
</style>
